<div>
  <label class="bmc-interface-adv__title">{{'INTERFACES.SECURITY_OPTIONS' | translate}}</label>
  <div class="bmc-interface-adv__empty-sec-options" 
    [ngClass]="{'bmc-interface-adv__empty-sec-options--rest': selectedInterface.interface.interfacetype === 'Rest'}"
    *ngIf="!selectedInterface.environment.messagesecurity?.length">
    <span>{{'INTERFACES.NOT_SECURITY_OPTIONS' | translate}}</span>
  </div>

  <div class="bmc-interface-adv-add-options__table-container">
    <table class="bmc-interface-adv-add-options__table bz-space--stack-xl" *ngIf="selectedInterface.environment.messagesecurity?.length">
      <thead>
        <tr>
          <th class="bz-table__cell">
            {{'INTERFACES.SECURITY_TYPE' | translate}}
          </th>
          <th class="bz-table__cell">
            {{'INTERFACES.USERNAME' | translate}}
          </th>
          <th class="bz-table__cell">
            {{'INTERFACES.PASSWORD' | translate}}
          </th>
          <th>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let securityOption of selectedInterface.environment.messagesecurity">
          <td class="bz-table__cell">
            <label *ngIf="editModeSecurityOption !== securityOption">{{securityOption.type}}</label>
            <bzg-select *ngIf="editModeSecurityOption === securityOption" [placeholder]="'GLOBAL.NONE' | translate"
              [isActive]="true" [value]="securityOption.type" (valueChange)="securityOption.type = $event">
              <bzg-option *ngFor="let securityType of securityTypes" [value]="securityType.name">
                <label>{{securityType.displayName}}</label>
              </bzg-option>
            </bzg-select>
          </td>
          <td class="bz-table__cell">
            <label *ngIf="editModeSecurityOption !== securityOption">{{securityOption.username}}</label>
            <bzg-input *ngIf="editModeSecurityOption === securityOption" type="text" name="username" [isActive]="true"
              [(ngModel)]="securityOption.username" placeholder="{{ 'INTERFACES.TYPE_USERNAME' | translate }}">
              <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-input>
          </td>
          <td class="bz-table__cell">
            <label *ngIf="editModeSecurityOption !== securityOption">*****************</label>
            <bzg-password name="password" *ngIf="editModeSecurityOption === securityOption"
              placeholder="{{ 'INTERFACES.TYPE_PASSWORD' | translate }}" [(ngModel)]="securityOption.password"
              [maxlength]="metadata['username'].max === -1 ? undefined : metadata['username'].max">
              <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
            </bzg-password>
          </td>
          <td class="bz-table__cell">
            <div class="bmc-interface-adv-add-options__table-icons">
              <div
                class="bmc-interface-adv-add-options__icon bmc-interface-adv-security-options__icon-save-edit bz-color-bg--theme-300"
                (click)="saveEditSecurityOption(securityOption)" *ngIf="editModeSecurityOption === securityOption">
                <bzg-icon [nameIcon]="'icon-check-mark'" [size]="18"></bzg-icon>
              </div>
              <bzg-icon class="bmc-interface-adv-security-options__field-icon-edit" [nameIcon]="'icon-edit'"
                *ngIf="editModeSecurityOption !== securityOption" [size]="18"
                (click)="editSecurityOption(securityOption)">
              </bzg-icon>
              <bzg-icon class="bmc-interface-adv-security-options__field-icons" [nameIcon]="'icon-delete'" [size]="18"
                (click)="removeSecurityOption(securityOption)">
              </bzg-icon>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bmc-interface-adv-add-options">
    <label class="bmc-interface-adv-add-options__title">{{'INTERFACES.ADD_SECURITY_OPTIONS' | translate}}</label>
    <form #addSecurityOptionsForm="ngForm" class="bmc-interface-adv-add-options__fields">
      <div class="bmc-interface-adv-add-options__field bz-space--inline-s">
        <label class="bmc-interface-adv-add-options__field-text">{{'INTERFACES.SECURITY_TYPE' | translate}}</label>
        <bzg-select [placeholder]="'GLOBAL.NONE' | translate" (valueChange)="changeSelectedSecurityType($event)">
          <bzg-option *ngFor="let secType of securityTypes" [value]="secType">
            {{secType.displayName}}
          </bzg-option>
        </bzg-select>
      </div>
      <div class="bmc-interface-adv-add-options__field bz-space--inline-s">
        <bzg-input type="text" name="username" placeholder="{{ 'INTERFACES.TYPE_USERNAME' | translate }}"
          [(ngModel)]="username" [required]="true"
          [maxlength]="metadata['username'].max === -1 ? undefined : metadata['username'].max">
          {{'INTERFACES.USERNAME' | translate}}
          <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
        </bzg-input>
      </div>
      <div class="bmc-interface-adv-add-options__field bz-space--inline-s">
        <bzg-password name="password" placeholder="{{ 'INTERFACES.TYPE_PASSWORD' | translate }}" [(ngModel)]="password"
          [required]="true" [maxlength]="metadata['username'].max === -1 ? undefined : metadata['username'].max">
          {{'INTERFACES.PASSWORD' | translate}}
          <bzg-required-error>{{'GLOBAL.REQUIRED_FIELD' | translate}}</bzg-required-error>
        </bzg-password>
      </div>
      <div class="bmc-interface-adv-add-options__field-action">
        <button class="bmc-interface-adv-add-options__icon bz-color-bg--theme-300" (click)="addSecurityOption()"
          [disabled]="!(password && username && selectedSecurityType) ">
          <bzg-icon [nameIcon]="'icon-plus'" [size]="18" class=""></bzg-icon>
        </button>
      </div>
    </form>
  </div>
</div>